module.exports = __webpack_public_path__ + "static/storyblock-0ef6acd82515678e1242d9fe797592b2.svg";